import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getSurvey } from "../../services/actions/_actions";
import { GET_SERVEY_LIST } from "../../services/actions/_actionType";
import MainLayout from "../layout/MainLayout";
import CancerEvaluationReHeader from "../layout/Header/CancerEvaluationReHeader";
import ResultList from "./ResultList";

const EvaluationResult = ({ survey, loading, requestApi }) => {
  useEffect(() => {
    requestApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <MainLayout
      header={<CancerEvaluationReHeader />}
      // footer={<CancerMainFooter onClick1={() => onPageMove()} />}
    >
      {loading ? (
        <>로딩중입니다.</>
      ) : (
        <>
          <ResultList survey={survey} />
        </>
      )}
    </MainLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    survey: state.survey,
    loading: state.loading[GET_SERVEY_LIST],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestApi: () => {
      dispatch(getSurvey());
    },
  };
};

export default connect(
  // 스토어와 연결
  mapStateToProps,
  mapDispatchToProps
)(EvaluationResult);
